import z from "zod";

const upstashErrorTypeValues = ["PLACEHOLDER_ERROR", "QUEUE_DEFINITION_NOT_FOUND"] as const;

const upstashErrorTypeSchema = z.enum(upstashErrorTypeValues);
const UpstashErrorType = upstashErrorTypeSchema.enum;
type UpstashErrorType = z.infer<typeof upstashErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type UpstashErrors =
  | {
      errorType: typeof UpstashErrorType.PLACEHOLDER_ERROR;
      data: Record<string, never>;
    }
  | {
      errorType: typeof UpstashErrorType.QUEUE_DEFINITION_NOT_FOUND;
      data: { queueName: string; availableQueues: string[] };
    };

export const upstashErrorDetails: Record<UpstashErrorType, ErrorDetails> = {
  [UpstashErrorType.PLACEHOLDER_ERROR]: {
    sentryDescription: "Upstash external service error",
  },
  [UpstashErrorType.QUEUE_DEFINITION_NOT_FOUND]: {
    sentryDescription: "Queue definition not found for the specified queue name",
  },
};
